module.exports = __webpack_public_path__ + "img/step.6cb78323.png";